export const DashboardSearchHelperText =
	"Search by Order #, PO #, Account #, Truck #, Confirmation # or Job Name (e.g. 1234567 or Kitchen Remodel)";
